import { Component } from '@angular/core';
import { IonNav, ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { ServiceRequestAnalyticsService } from '@usf/ngrx-list';
import { ServiceRequestService } from '@service-request/services/service-request.service';
import { OrderAndProductOptionsBaseComponent } from '../../order-and-product-options-base.component';

@Component({
  selector: 'app-product-options-touch',
  templateUrl: './product-options-touch.component.html',
  styleUrls: ['../../../request-credit-common-styles.scss'],
})
export class ProductOptionsTouchComponent extends OrderAndProductOptionsBaseComponent {
  constructor(
    nav: IonNav,
    modalController: ModalController,
    platformService: PlatformService,
    serviceRequestService: ServiceRequestService,
    serviceRequestAnalyticsService: ServiceRequestAnalyticsService,
  ) {
    super(
      nav,
      modalController,
      platformService,
      serviceRequestService,
      serviceRequestAnalyticsService,
    );
  }

  async goBack() {
    this.serviceRequestService.searchKey = '';
    await this.nav.pop();
  }
}
